import { useEffect, useState, type FormEvent } from 'react';
import { Send } from 'lucide-react';
import { api } from '../../api/client';
import { useAuth } from '../../state/auth';
import { useLanguage } from '../../i18n/LanguageProvider';
import { helpUrl } from '../../config/navigation';
import { Header, Button } from '../../ui';
import './guest-help.css';

export function GuestHelpScreen() {
  const { status, user } = useAuth();
  const { language } = useLanguage();
  const en = language === 'en';
  const hasCabinet = status === 'authenticated' && (user?.active_role === 'customer' || user?.active_role === 'carrier');
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '', website: '' });
  const [state, setState] = useState<'ready' | 'sending' | 'sent'>('ready');
  const [error, setError] = useState('');
  useEffect(() => {
    if (hasCabinet && user) window.location.assign(helpUrl(user.active_role));
  }, [hasCabinet, user]);
  async function send(event: FormEvent) {
    event.preventDefault();
    if (state === 'sending') return;
    setState('sending'); setError('');
    try {
      // Establish a CSRF cookie even when this page is opened directly.
      await api('/api/support/contact/');
      await api('/api/support/contact/', { method: 'POST', body: form });
      setState('sent');
    } catch {
      setState('ready');
      setError(en ? 'Could not send your message. Please try again later.' : 'Не удалось отправить письмо. Попробуйте позже.');
    }
  }
  if (hasCabinet) return null;
  return <div className="guest-help"><Header /><main className="guest-help__content" data-i18n-skip>
    <h1>{en ? 'Contact support' : 'Написать в поддержку'}</h1>
    {state === 'sent' ? <div role="status"><p>{en ? 'Your message has been sent. We will reply by email.' : 'Письмо отправлено. Ответ придёт на ваш email.'}</p><a href="/#landing">{en ? 'Home' : 'На главную'}</a></div> : <form onSubmit={send}>
      {([['name', en ? 'Name' : 'Имя'], ['email', 'Email'], ['subject', en ? 'Subject' : 'Тема']] as const).map(([field, title]) => <label key={field}>{title}<input type={field === 'email' ? 'email' : 'text'} autoComplete={field === 'subject' ? 'off' : field} required maxLength={field === 'email' ? 254 : 160} disabled={state === 'sending'} value={form[field]} onChange={(event) => setForm({ ...form, [field]: event.target.value })} /></label>)}
      <label>{en ? 'Message' : 'Сообщение'}<textarea required minLength={10} maxLength={5000} rows={6} disabled={state === 'sending'} value={form.message} onChange={(event) => setForm({ ...form, message: event.target.value })} /></label>
      <label className="guest-help__trap" aria-hidden="true">Website<input tabIndex={-1} autoComplete="off" value={form.website} onChange={(event) => setForm({ ...form, website: event.target.value })} /></label>
      {error ? <p role="alert">{error}</p> : null}
      <Button type="submit" disabled={state === 'sending'}><Send size={18} aria-hidden />{state === 'sending' ? (en ? 'Sending…' : 'Отправляем…') : (en ? 'Send message' : 'Отправить письмо')}</Button>
    </form>}
  </main></div>;
}
